var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GChart',{attrs:{"settings":{ packages: ['orgchart'] },"type":"OrgChart","data":_vm.chartData},on:{"ready":_vm.drawCharts}})}
var staticRenderFns = []

export { render, staticRenderFns }